import type Big from 'big.js'
import type { NotificationActionTypes } from 'components'
import type { SuccessPayload } from 'components/widgets/invest-component/storage/invest-states'

export type TransactionResult = {
  hash: string
  params: SuccessPayload
  buyAmount: Big
  isUserContract: boolean
  chains?: number[]
  isSingleChain?: boolean
  action?: NotificationActionTypes
}

export const parseTransactionResult = (
  hash: string,
  params: SuccessPayload,
  buyAmount: Big,
  isSingleChain?: boolean,
  chains?: number[],
  action?: NotificationActionTypes,
): TransactionResult => {
  return {
    hash,
    params,
    buyAmount,
    isUserContract: params.isUserContract,
    chains,
    isSingleChain,
    action,
  }
}
